import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaBars, FaTimes, FaGithub, FaLinkedin } from 'react-icons/fa';
import styles from './Navbar.module.css';
// import ThemeToggle from './ThemeToggle';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Scroll detect karke glass effect activate karna
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { title: 'Home', href: '#hero' },
    { title: 'About', href: '#about' },
    { title: 'Experience', href: '#experience' },
    { title: 'Projects', href: '#projects' },
    { title: 'Contact', href: '#contact' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`${styles.navbar} ${scrolled ? styles.scrolled : ''}`}
    >
      <div className={styles.container}>
        {/* Logo */}
        <a href="#hero" className={styles.logo}>
          Prince<span className={styles.dot}>.</span>
        </a>

        {/* Desktop Menu */}
        <ul className={styles.desktopMenu}>
          {navLinks.map((link, index) => (
            <li key={index}>
              <a href={link.href} className={styles.navLink}>
                {link.title}
              </a>
            </li>
          ))}
        </ul>

        {/* <div style={{ marginLeft: '20px' }}>
          <ThemeToggle />
        </div> */}

        {/* Social & Resume Buttons */}
        <div className={styles.actions}>
          <a href="https://github.com/princedesai012" target="_blank" rel="noreferrer" className={styles.iconBtn}><FaGithub /></a>
          <a href="https://www.linkedin.com/in/prince-desai-420910282" target="_blank" rel="noreferrer" className={styles.iconBtn}><FaLinkedin /></a>
          <a href="/Prince_Desai_Resume.pdf" download className={styles.resumeBtn}>
            Resume
          </a>
        </div>

        {/* Mobile Hamburger */}
        <div className={styles.hamburger} onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: '100vh' }}
            exit={{ opacity: 0, height: 0 }}
            className={styles.mobileMenu}
          >
            {navLinks.map((link, index) => (
              <motion.a
                key={index}
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.1 * index }}
                href={link.href}
                onClick={() => setIsOpen(false)}
                className={styles.mobileLink}
              >
                {link.title}
              </motion.a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;